import { URL_ACCOUNT_INVOICING_PAYABLE } from '@seek/adv-constants';
import { useMelwaysLink } from '@seek/melways-react';
import { useTranslations } from '@vocab/react';
import { Stack, Strong, Text, TextLink } from 'braid-design-system';

import translations from './.vocab';

interface Props {
  userCanPayInvoices: boolean;
  onHandleOutstandingClick: () => void;
}

export const CreditHoldBody = ({
  userCanPayInvoices,
  onHandleOutstandingClick,
}: Props) => {
  const { t } = useTranslations(translations);
  const invoicePayableUrl = useMelwaysLink(URL_ACCOUNT_INVOICING_PAYABLE);

  return (
    <Stack space="medium">
      <Text>
        <Strong>{t('credit-hold-heading')}</Strong>
      </Text>
      <Text>
        {userCanPayInvoices
          ? t('credit-hold-message-admin', {
              Link: (children) => (
                <TextLink
                  href={invoicePayableUrl}
                  rel="noopener noreferrer"
                  target="_blank"
                  onClick={onHandleOutstandingClick}
                >
                  {children}
                </TextLink>
              ),
            })
          : t('credit-hold-message-non-admin')}
      </Text>
    </Stack>
  );
};
